<template>
    <div class="w-100">
        <div v-for="(condition, index) in conditions" :key="index" class="d-flex align-center mb-2">
            <v-col class="pl-0 pr-1">
                <v-combobox
                    v-model="condition.fieldName"
                    :items="fields"
                    item-value="value"
                    item-text="text"
                    menu-props="auto"
                    label="Field Name"
                    dense
                    @change="(val) => condition.fieldName = val.value || val"
                >
                </v-combobox>
            </v-col>

            <v-col class="pl-0 pr-1" v-if="['product-meta', 'order-meta', 'source-data'].includes(condition.fieldName)">
                <v-combobox
                    v-model="condition.metaFieldName"
                    :items="condition.fieldName == 'product-meta' ? productMetaFields : orderMetaFields"
                    item-value="value"
                    item-text="text"
                    menu-props="auto"
                    label="Field Name"
                    dense
                    @change="(val) => condition.metaFieldName = val.value || val"
                >
                </v-combobox>
            </v-col>

            <v-col class="px-1">
                <v-select
                    :items="operators"
                    v-model="condition.operator"
                    label="Operator"
                    dense>
                </v-select>
            </v-col>

            <v-col class="px-1">
                <v-text-field
                    label="Value"
                    v-model="condition.value"
                    dense/>
            </v-col>

            <v-col cols="1" class="d-flex align-center justify-end pl-1 pr-0">
                <v-btn
                    x-small
                    class="mr-1"
                    @click="addConditionRow(index)">
                    +
                </v-btn>
                <v-btn
                    x-small
                    @click="removeConditionRow(index)"
                    :disabled="conditions.length === 1">
                    -
                </v-btn>
            </v-col>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        conditions: {
            type: Array,
            default: () => [
                {
                    fieldName: null,
                    metaFieldName: null,
                    operator: null,
                    value: ''
                }
            ]
        }
    },
    data() {
        return {
            fields: [
                // standard items fields
                { header: 'Standard Item Fields' },
                'sku',
                'name',
                'boxes',
                'itemType',
                'quantity',
                'boxQuantity',
                {
                    text: 'weight (kg)',
                    value: 'weight',
                },
                {
                    text: 'length (cm)',
                    value: 'length',
                },
                {
                    text: 'width (cm)',
                    value: 'width',
                },
                {
                    text: 'height (cm)',
                    value: 'height',
                },
                { header: 'Product Field Options' },
                'productId',
                'parentProductId',
                'productGroup',
                'orderedQuantity',
                'itemPrice',
                'packIndividually',
                {
                    text: 'stackHeightAddition (cm)',
                    value: 'stackHeightAddition',
                },
                'maxStackQuantity',
                'additionalSkus',
                'componentSkus',
                'isParentItem',
                'isChildItem',
                'isLivePricing',
                'isInternational',

                { header: 'International Field Options' },
                'harmonizedCode',
                'countryOfManufactureCode',
                'dollarValue',

                { header: 'DG Field Options' },
                'companyDgItemId',
                'aggregateQuantity',

                { header: 'Product Count Options' },
                {
                    text: 'Total Ordered Product Count',
                    value: 'total-ordered-product-count',
                },
                {
                    text: 'Unpacked Product Count',
                    value: 'unpacked-product-count',
                },
                { header: 'Product Cubic Options' },
                {
                    text: 'Total Order Cubic (cm3)',
                    value: 'total-order-cubic',
                },
                {
                    text: 'Unpacked Items Cubic (cm3)',
                    value: 'unpacked-items-cubic',
                },
                { header: 'Product Weight Options' },
                {
                    text: 'Largest Item Weight (kg)',
                    value: 'largest-item-weight',
                },
                {
                    text: 'Largest Unpacked Item Weight (kg)',
                    value: 'largest-unpacked-item-weight',
                },
                {
                    text: 'Total Order Weight (kg)',
                    value: 'total-order-weight',
                },
                {
                    text: 'Total Unpacked Order Weight (kg)',
                    value: 'total-unpacked-order-weight',
                },
                { header: 'Order Field Options' },
                {
                    text: 'Total Order Price',
                    value: 'total-order-price',
                },
                { header: 'Order Contains' },
                {
                    text: 'Product SKU',
                    value: 'ordered-product-sku',
                },
                {
                    text: 'Product Name',
                    value: 'ordered-product-name',
                },
                {
                    text: 'Product itemType',
                    value: 'ordered-product-itemType',
                },
                { header: 'Custom Fields' },
                {
                    text: 'Product Meta',
                    value: 'product-meta',
                },
                {
                    text: 'Order Meta',
                    value: 'order-meta',
                },
                {
                    text: 'Source Data',
                    value: 'source-data',
                },
            ],
            productMetaFields: [
                // we can define default product meta fields here in the future
            ],
            orderMetaFields: [
                // we can define default order meta fields here in the future
            ],
            operators: [
                'Contains',
                'In List',
                'Not In List',
                '==',
                '!=',
                '<',
                '<=',
                '>',
                '>='
            ],
        };
    },
    methods: {
        addConditionRow(index) {
            // Insert a new field immediately after the current one
            this.conditions.splice(index + 1, 0, { fieldName: null, operator: null, value: '' });
        },
        removeConditionRow(index) {
            // Remove row at the specified index
            if (this.conditions.length > 1) {
                this.conditions.splice(index, 1);
            }
        },
    },

    watch: {
        conditions: {
            handler(newVal) {
                // Emit the updated conditions array to the parent component
                this.$emit('updateRuleCondition', newVal);
            },
            deep: true
        }
    }
};
</script>
